//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as uiAction from '../action/uiAction';
//Material-ui
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Fab from '@material-ui/core/Fab';
import Divider from '@material-ui/core/Divider';
//Part
import PartUserName from './PartUserName';
import PartMyPhoto from './PartMyPhoto';
import MenuMyProfile from './MenuMyProfile';
import PartMyProof from './PartMyProof';
import PartRequestBalloon from './PartRequestBalloon';
import PartCoupleIcon from './PartCoupleIcon';
//Icon
import EditIcon from '@material-ui/icons/Edit';
import { FaAddressCard } from 'react-icons/fa';

import VisibilityIcon from '@material-ui/icons/Visibility';

class Comp extends React.Component {

  constructor(props) {
		super(props);
    this.state = {
      profile: null,
      mainPhotoDialog: false,
    }
	}

  componentDidMount() {
    document.title = 'プロフィール - パートナーズ';

    const hash = window.location.hash.replace("#", "");
    if (hash) {
      let elem = document.getElementById(hash);
      if (elem) {
        let rect = elem.getBoundingClientRect();
        window.scrollTo(0, (window.pageYOffset + rect.top - document.getElementById('header_menu').clientHeight));
      }
    }
  }

  _profileUserEditPopoverOpen(event) {
    this.props.popoverOpen(
      event.currentTarget,
      (<span style={{cursor:'pointer'}} onClick={ () => {this.props.history.push('/my/user/'); this.props.popoverClose()} }>プロフィールを編集する</span>)
    )
  }

  _profilePartnerEditPopoverOpen(event) {
    this.props.popoverOpen(
      event.currentTarget,
      (<span style={{cursor:'pointer'}} onClick={ () => {this.props.history.push('/my/partner/'); this.props.popoverClose()} }>希望条件を編集する</span>)
    )
  }


  render() {
    let profile = this.props.my.profile;
    let request = this.props.my.request;

      return (
        <div>
          <MenuMyProfile />

          <div style={{textAlign:'center',paddingTop:'15px'}}>
            <span style={{display:'inline-block',position:'relative'}}>
              <PartUserName
                data={{
                  name: profile.userdata_name,
                  sex: profile.userdata_sex,
                  size: '1.8em',
                }}
              />
              <EditIcon
                style={{position:'absolute',right:'-30px',top:'5px',color:'#999',cursor:'pointer'}}
                onClick={ () => this.props.history.push('/setting/name/') }
              />
            </span>
          </div>

          <div style={{textAlign:'center'}}>
            <div style={{color:'#666', fontSize:'1.1em'}}>
              {
                (profile.userdata_sex === 'men') ? '男性': '女性'
              }
              {
                (this.props.my.proof.person !== 1) && (
                  <EditIcon
                    style={{color:'#999',cursor:'pointer'}}
                    onClick={ (event) => this.props.popoverOpen(
                      event.currentTarget,
                      (
                        <div>
                          性別をお間違いの場合、サポートにお問い合わせください　<br />
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={ () => {this.props.history.push('/contact/sexEdit');this.props.popoverClose();} }
                          >
                            お問い合わせ
                          </Button>
                        </div>
                      )
                    ) }
                  />
                )
              }

              &nbsp;
              {profile.userdata_age}才

              {
                (this.props.my.proof.person !== 1) && (
                  <EditIcon
                    style={{color:'#999',cursor:'pointer'}}
                    onClick={ () => this.props.history.push('/setting/birthday/') }
                  />
                )
              }

            </div>
          </div>

          <div style={{margin:'20px 0px'}} align='center'>
            {
              (this.props.notification.couple) && (
                <PartCoupleIcon />
              )
            }

            <div style={{maxWidth:'600px'}} id='myProofBox'>

              <PartMyProof />
              {
                ((request.proof.person + request.proof.photo + request.proof.income + request.proof.single) > 0) &&
                <div style={{textAlign:'center'}}>
                  <PartRequestBalloon
                    color={'blue'}
                    arrow={'top'}
                  >
                    <div>
                      {(request.proof.person > 0) && '本人証明 '}
                      {(request.proof.photo > 0) && '写真証明 '}
                      {(request.proof.income > 0) && '収入証明 '}
                      {(request.proof.single > 0) && '独身証明 '}
                      を申請中
                    </div>
                    <div>12時間以内に申請結果をメールでお知らせします</div>
                  </PartRequestBalloon>
                </div>
              }
              <div style={{textAlign:'center'}}>
                <Fab
                  variant="extended"
                  color="primary"
                  onClick={ () => this.props.history.push('/my/proof/') }
                >
                  <FaAddressCard style={{fontSize:'1.5em'}} />&nbsp;
                  証明書を編集
                </Fab>

              </div>
            </div>
          </div>

          <Divider/>

          <div style={{margin:'20px 0px'}} align='center' id='photoBlock'>
            <PartMyPhoto />
          </div>

          <Divider/>
          <div align='center' style={{margin:'15px'}}>
            <Box
              className='round12'
              boxShadow={2}
              style={{
                display:'inline-block',
                maxWidth:'400px',
                margin:'auto',
                padding:'10px',
                background:'#FFF',
            }}>
              <div
                style={{
                  padding:'10px',
                  display:'flex',
                  flexDirection:'row',
                  justifyContent:'space-between',
                }}
              >
                <h2>
                  パートナーへ一言
                </h2>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={ () => this.props.history.push('/my/comment/#partnerComment') }
                >
                  編集
                </Button>
              </div>

              {
                (request.profile === 1) ? (
                  <>
                    <div style={{whiteSpace:'pre-line',textAlign:'left'}}>
                      {this.props.my.request.profileLog.partnerComment}
                    </div>
                    <div style={{textAlign:'center'}}>
                      <PartRequestBalloon
                        color={'red'}
                        arrow={'top'}
                      >
                        <div>コメントは申請中です</div>
                        <div>12時間以内に結果をメールでお知らせします</div>
                      </PartRequestBalloon>
                    </div>
                  </>
                ):(
                  <div style={{whiteSpace:'pre-line',textAlign:'left'}}>
                    {　
                      (profile.userdata_prof_partner_comment) ? (
                        <div>{profile.userdata_prof_partner_comment}</div>
                      ): (
                        <div style={{margin:'5px 15px', color:'#999'}}>未登録</div>
                      )
                    }
                  </div>
                )
              }
            </Box>
          </div>

          <div className='profile_block'>
            <div className='col2'>
              <Box
                id='myProfileUserBox'
                className='round12'
                boxShadow={2}
                style={{
                  background:'#FFF',
                  margin:'15px'
                }}
              >
                <div
                  style={{
                    padding:'10px',
                    display:'flex',
                    flexDirection:'row',
                    justifyContent:'space-between',
                  }}
                >
                  <h2>
                    プロフィール
                  </h2>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={ () => this.props.history.push('/my/user/') }
                  >
                    編集
                  </Button>
                </div>
                <table className='profileTable'>
                  <tbody>
                    <tr>
                      <td className='title'><div className='text'>地域</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_region} {profile.userdata_prof_region_detail}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>出身</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_birthplace} {profile.userdata_prof_birthplace_detail}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>続柄</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_relationship}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>仕事</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_job}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>休日</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_holiday}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>年収</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_income}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>学歴</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_academic}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>宗教</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_religion}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>体型</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_style}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>身長</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_height}cm
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>交際希望</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_association}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>結婚歴</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_marriage}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>生活</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_lifestyle}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>子供</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_child}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>ペット</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_pet}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>住居</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_house}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>車</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_car}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>タバコ</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_smorking}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>お酒</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_drinking}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>ギャンブル</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_gambling}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>血液型</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_blood}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'><div className='text'>星座</div></td>
                      <td className='value' onClick={ (event) => this._profileUserEditPopoverOpen(event) }>
                        {profile.userdata_prof_constellation}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Box>

              <Box
                id='myProfilePartnerBox'
                className='round12'
                boxShadow={2}
                style={{
                  background:'#FFF',
                  margin:'15px'
                }}
              >
                <div
                  style={{
                    padding:'10px',
                    display:'flex',
                    flexDirection:'row',
                    justifyContent:'space-between',
                  }}
                >
                  <h2>
                    パートナーへの希望
                  </h2>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={ () => this.props.history.push('/my/partner/') }
                  >
                    編集
                  </Button>
                </div>

                <table className='profileTable'>
                  <tbody>
                    <tr>
                      <td className='title'>
                        <div className='text'>年齢</div>
                        {
                          (profile.userdata_prof_partner_age_important === 1) &&
                          <span className='importantIcon'>重要</span>
                        }
                      </td>
                      <td className='value' onClick={ (event) => this._profilePartnerEditPopoverOpen(event) }>
                        {profile.userdata_prof_partner_age_low} 〜 {profile.userdata_prof_partner_age_high}才
                      </td>
                    </tr>
                    <tr>
                      <td className='title'>
                        <div className='text'>地域</div>
                        {
                          (profile.userdata_prof_partner_region_important === 1) &&
                          <span className='importantIcon'>重要</span>
                        }
                      </td>
                      <td className='value' onClick={ (event) => this._profilePartnerEditPopoverOpen(event) }>
                        {profile.userdata_prof_partner_region}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'>
                        <div className='text'>仕事</div>
                        {
                          (profile.userdata_prof_partner_job_important === 1) &&
                          <span className='importantIcon'>重要</span>
                        }
                      </td>
                      <td className='value' onClick={ (event) => this._profilePartnerEditPopoverOpen(event) }>
                        {profile.userdata_prof_partner_job}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'>
                        <div className='text'>年収</div>
                        {
                          (profile.userdata_prof_partner_income_important === 1) &&
                          <span className='importantIcon'>重要</span>
                        }
                      </td>
                      <td className='value' onClick={ (event) => this._profilePartnerEditPopoverOpen(event) }>
                        {profile.userdata_prof_partner_income.replace(/,/g, '\n')}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'>
                        <div className='text'>学歴</div>
                        {
                          (profile.userdata_prof_partner_academic_important === 1) &&
                          <span className='importantIcon'>重要</span>
                        }
                      </td>
                      <td className='value' onClick={ (event) => this._profilePartnerEditPopoverOpen(event) }>
                        {profile.userdata_prof_partner_academic}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'>
                        <div className='text'>体型</div>
                        {
                          (profile.userdata_prof_partner_style_important === 1) &&
                          <span className='importantIcon'>重要</span>
                        }
                      </td>
                      <td className='value' onClick={ (event) => this._profilePartnerEditPopoverOpen(event) }>
                        {profile.userdata_prof_partner_style}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'>
                        <div className='text'>身長</div>
                        {
                          (profile.userdata_prof_partner_height_important === 1) &&
                          <span className='importantIcon'>重要</span>
                        }
                      </td>
                      <td className='value' onClick={ (event) => this._profilePartnerEditPopoverOpen(event) }>
                        {profile.userdata_prof_partner_height_low} 〜 {profile.userdata_prof_partner_height_high}cm
                      </td>
                    </tr>
                    <tr>
                      <td className='title'>
                        <div className='text'>交際希望</div>
                        {
                          (profile.userdata_prof_partner_association_important  === 1) &&
                          <span className='importantIcon'>重要</span>
                        }
                      </td>
                      <td className='value' onClick={ (event) => this._profilePartnerEditPopoverOpen(event) }>
                        {profile.userdata_prof_partner_association}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'>
                        <div className='text'>結婚歴</div>
                        {
                          (profile.userdata_prof_partner_marriage_important === 1) &&
                          <span className='importantIcon'>重要</span>
                        }
                      </td>
                      <td className='value' onClick={ (event) => this._profilePartnerEditPopoverOpen(event) }>
                        {profile.userdata_prof_partner_marriage}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'>
                        <div className='text'>生活</div>
                        {
                          (profile.userdata_prof_partner_lifestyle_important === 1) &&
                          <span className='importantIcon'>重要</span>
                        }
                      </td>
                      <td className='value' onClick={ (event) => this._profilePartnerEditPopoverOpen(event) }>
                        {profile.userdata_prof_partner_lifestyle}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'>
                        <div className='text'>子供</div>
                        {
                          (profile.userdata_prof_partner_child_important === 1) &&
                          <span className='importantIcon'>重要</span>
                        }
                      </td>
                      <td className='value' onClick={ (event) => this._profilePartnerEditPopoverOpen(event) }>
                        {profile.userdata_prof_partner_child}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'>
                        <div className='text'>ペット</div>
                        {
                          (profile.userdata_prof_partner_pet_important === 1) &&
                          <span className='importantIcon'>重要</span>
                        }
                      </td>
                      <td className='value' onClick={ (event) => this._profilePartnerEditPopoverOpen(event) }>
                        {profile.userdata_prof_partner_pet}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'>
                        <div className='text'>タバコ</div>
                        {
                          (profile.userdata_prof_partner_smorking_important === 1) &&
                          <span className='importantIcon'>重要</span>
                        }
                      </td>
                      <td className='value' onClick={ (event) => this._profilePartnerEditPopoverOpen(event) }>
                        {profile.userdata_prof_partner_smorking}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'>
                        <div className='text'>お酒</div>
                        {
                          (profile.userdata_prof_partner_drinking_important === 1) &&
                          <span className='importantIcon'>重要</span>
                        }
                      </td>
                      <td className='value' onClick={ (event) => this._profilePartnerEditPopoverOpen(event) }>
                        {profile.userdata_prof_partner_drinking}
                      </td>
                    </tr>
                    <tr>
                      <td className='title'>
                        <div className='text'>ギャンブル</div>
                        {
                          (profile.userdata_prof_partner_gambling_important === 1) &&
                          <span className='importantIcon'>重要</span>
                        }
                      </td>
                      <td className='value' onClick={ (event) => this._profilePartnerEditPopoverOpen(event) }>
                        {profile.userdata_prof_partner_gambling}

                      </td>
                    </tr>
                  </tbody>
                </table>
              </Box>
            </div>

            <div className='col2'>
              <Box
                id='myProfileCommentBox'
                className='round12'
                boxShadow={2}
                style={{
                  background:'#FFF',
                  margin:'15px',
                  padding:'10px',
                }}
              >
                <div
                  style={{
                    padding:'10px',
                    display:'flex',
                    flexDirection:'row',
                    justifyContent:'space-between',
                  }}
                >
                  <h2>
                    自己紹介
                  </h2>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={ () => this.props.history.push('/my/comment/') }
                  >
                    編集
                  </Button>
                </div>

                {
                  (request.profile === 1)  ? (
                    <>
                      <div style={{whiteSpace:'pre-line'}}>
                        {this.props.my.request.profileLog.comment}
                      </div>
                      <div style={{textAlign:'center'}}>
                        <PartRequestBalloon
                          color={'red'}
                          arrow={'top'}
                        >
                          <div>コメントは申請中です</div>
                          <div>12時間以内に結果をメールでお知らせします</div>
                        </PartRequestBalloon>
                      </div>
                    </>
                  ): (
                    (profile.userdata_prof_comment) ? (
                      <div style={{whiteSpace:'pre-line'}}>{profile.userdata_prof_comment}</div>
                    ): (
                      <div style={{color:'#999'}}>未登録</div>
                    )
                  )

                }

              </Box>



              <Box
                className='round12'
                boxShadow={2}
                style={{
                  margin:'15px',
                  padding:'10px',
                  background:'#fff',
                  textAlign:'left',
                }}
              >
                <div
                  style={{
                    padding:'10px',
                    display:'flex',
                    flexDirection:'row',
                    justifyContent:'space-between',
                  }}
                >
                  <h2>
                    キーワード
                  </h2>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={ () => this.props.history.push('/my/keyword/') }
                  >
                    編集
                  </Button>
                </div>

                <div>
                  {
                    (this.props.my.keyword.length > 0) ? (
                      this.props.my.keyword.map(
                        (value, index, arr) => {
                          return (
                            <Chip
                              key={index}
                              label={ value.text }
                              variant="outlined"
                              style={{margin:'3px'}}
                            />
                          )
                        }
                      )
                    ) : (
                      <div style={{margin:'5px 15px', color:'#999'}}>未登録</div>
                    )
                  }
                </div>
              </Box>

              <Box
                className='round12'
                boxShadow={2}
                style={{
                  margin:'15px',
                  padding:'10px',
                  background:'#fff',
                  textAlign:'left',
                }}
                id='myProofWant'
              >
                <div
                  style={{
                    padding:'10px',
                    display:'flex',
                    flexDirection:'row',
                    justifyContent:'space-between',
                  }}
                >
                  <h2>
                    希望する証明書
                  </h2>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={ () => this.props.history.push('/my/proofWant/') }
                  >
                    編集
                  </Button>
                </div>

                <div>
                  {
                    (this.props.my.proof.personWant === 1) && (
                      <span className='proof_icon'>本人証明</span>
                    )
                  }
                  {
                    (this.props.my.proof.photoWant === 1) && (
                      <span className='proof_icon'>写真証明</span>
                    )
                  }
                  {
                    (this.props.my.proof.incomeWant === 1) && (
                      <span className='proof_icon'>収入証明</span>
                    )
                  }
                  {
                    (this.props.my.proof.singleWant === 1) && (
                      <span className='proof_icon'>独身証明</span>
                    )
                  }
                  {
                    (this.props.my.proof.personWant === 0 && this.props.my.proof.photoWant === 0 && this.props.my.proof.incomeWant === 0 && this.props.my.proof.singleWant === 0) && (
                      <div style={{margin:'5px 15px', color:'#999'}}>未登録</div>
                    )
                  }
                </div>
              </Box>

            </div>
          </div>

          <div style={{height:'60px'}}></div>

          <div style={{position:'fixed',bottom:'0px',left:'0px',width:'100%', pointerEvents:'none'}}>
            <div style={{maxWidth:'900px', margin:'auto', textAlign:'right', pointerEvents:'none'}}>
              <Fab
                variant="extended"
                onClick={ () => this.props.history.push('/my/preview/') }
                style={{margin:'10px', pointerEvents:'auto'}}
                color="secondary"
              >
                <VisibilityIcon />&nbsp;
                プレビュー
              </Fab>
            </div>
          </div>

        </div>

      )

  }
}


const mapStateToProps = (state) => {
	return {
		ui: state.ui,
    my: state.my,
    notification: state.notification,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...uiAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
